const appKey = process.env.GATSBY_APP
if (!appKey) {
  throw new Error("appKey 不能为空")
}

const title = "GPASS 2026 秋季促销 回归游戏季"
const desc = "本季度GPASS将回归游戏，从游戏出发"

const cdnUrl = "https://site.gcores.com"

module.exports = {
  appKey,
  cdnUrl,
  pageUrl: `${cdnUrl}/${appKey}/`,
  appInfo: {
    name: title,
    description: desc,
    shareTitle: title,
    shareDescription: desc,
  },
  links: {
    gpass: "https://www.gcores.com/gpass",
  },
}
